import { useQuery } from 'react-query';
import { WidgetsDTO } from '../../AccountPerformanceReporting/api/useWidgetsQuery';
import { authFetch } from '../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';
import { setDefaults } from '../util/normalizeWidgets';

export type WidgetSlugDTO =
  | 'Activity'
  | 'Allocation'
  | 'Income'
  | 'Performance'
  | 'Summary'
  | 'RiskProfile'
  | 'RmdDashboard'
  | 'UnRealizedGainLoss'
  | 'RealizedGainLoss'
  | 'GainLoss';

export type DefaultWidgetsTemplateDTO = Record<WidgetSlugDTO, WidgetsDTO>;

export const fetchDefaultTemplate = async (): Promise<DefaultWidgetsTemplateDTO> => {
  const response: DefaultWidgetsTemplateDTO = await authFetch(
    '/Adviser/PersonalFinanceTemplates/GetDefaultTemplate',
  );

  return setDefaults(response);
};

interface Args {
  enabled?: boolean;
}

export const useDefaultTemplateQuery = ({ enabled }: Args) => {
  return useQuery(queryKeys.defaultTemplate(), () => fetchDefaultTemplate(), { enabled });
};
